import OrdersList from "../../components/Orders/OrdersList";

const ordersRoutes = [
    { path: '', name: 'ordersList', component: OrdersList,
    },
];

export default ordersRoutes;
